module.exports = __webpack_public_path__ + "static/media/helicoptero_azul.08b24e83.svg";